import React from 'react';
import styled from 'styled-components';

import { IUEvent } from '../../lib/event';
import { useEditEventContext } from '../../contexts/EditEventContext';
import EditableQuestion from './EditableQuestion';
import Plus from '../icons/Plus';

interface Props {
  event: IUEvent;
}

const Questions = ({ event }: Props) => {
  const editEventContext = useEditEventContext();

  const onAddClick = () => {
    editEventContext.addAQuestion();
  };

  if (event.questions.length === 0) {
    return <Container>
      <AddAQuestion onClick={onAddClick}><PlusContainer><Plus
        size={20}/></PlusContainer>{'  Add a question for your guests'}
      </AddAQuestion>
    </Container>;
  } else {
    return <Container>
      {
        event.questions.map((question) =>
          <EditableQuestion key={question.questionUuid} question={question} event={event}/>)
      }
      <AddAQuestion onClick={onAddClick}><PlusContainer><Plus size={20}/></PlusContainer>{'  Add a question'}
      </AddAQuestion>
    </Container>;
  }
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  color: var(--shine-background-text-color);
`;

const PlusContainer = styled.div`
  margin-right: 10px;
`;

const AddAQuestion = styled.div`
  display: flex;
  text-align: center;
  margin: 15px 0;
  font-size: 18px;
  font-weight: 300;
  cursor: pointer;
`;

export default Questions;
